import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Loader2 } from 'lucide-react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { adminLogin } from '../lib/adminApi';

export const AdminLogin = ({ onSuccess }) => {
  const [pin, setPinValue] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!pin) return;
    setBusy(true);
    setError(null);
    try {
      await adminLogin(pin);
      onSuccess();
    } catch (err) {
      setError(err.message || 'Login mislukt');
      setPinValue('');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <Card className="p-10 bg-card border-2 border-border">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-primary/10 flex items-center justify-center">
            <ShieldCheck className="w-8 h-8 text-primary" />
          </div>
          <h1 className="text-2xl font-bold text-foreground text-center mb-2">Admin Toegang</h1>
          <p className="text-sm text-muted-foreground text-center mb-8">Voer je PIN in om door te gaan</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="password"
              inputMode="numeric"
              autoFocus
              value={pin}
              onChange={(e) => setPinValue(e.target.value)}
              placeholder="PIN"
              data-testid="admin-pin-input"
              className="text-center text-2xl tracking-[0.5em] h-14"
            />
            {error && (
              <p className="text-sm text-red-400 text-center" data-testid="admin-pin-error">{error}</p>
            )}
            <Button
              type="submit"
              disabled={busy || !pin}
              data-testid="admin-pin-submit"
              className="w-full bg-primary hover:bg-primary/90 text-primary-foreground py-6 text-lg"
            >
              {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Inloggen'}
            </Button>
          </form>
        </Card>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
